import React from "react";
import { observer } from "mobx-react";
import { UserNotificationPreferenceCreateStore } from "../../store";
import { UserNotificationPreferenceCreateForm } from "./UserNotificationPreferenceCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { NotificationType } from "../../../../api/graphql";
import { EmailFrequency } from "../../../../api/graphql";

export type UserNotificationPreferenceCreateProps = {
  userNotificationPreferenceCreateStore: UserNotificationPreferenceCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const UserNotificationPreferenceCreate: React.FC<UserNotificationPreferenceCreateProps> =
  observer(
    ({
      userNotificationPreferenceCreateStore,
      showToolbox = true,
      showSaveFooter,
    }) => {
      return (
        <>
          <SavingOverlay
            open={userNotificationPreferenceCreateStore.isSaving}
          />
          <UserNotificationPreferenceCreateForm
            userNotificationPreferenceCreateStore={
              userNotificationPreferenceCreateStore
            }
            notificationTypeError={
              userNotificationPreferenceCreateStore.errors.notificationType
                ?.message
            }
            notificationTypeOptions={userNotificationPreferenceCreateStore.getNotificationTypeOptions()}
            onNotificationTypeChange={(value: NotificationType) => {
              userNotificationPreferenceCreateStore.setNotificationTypeValue(
                value
              );
            }}
            notificationType={
              userNotificationPreferenceCreateStore.entityValues
                .notificationType
            }
            inAppEnabledError={
              userNotificationPreferenceCreateStore.errors.inAppEnabled?.message
            }
            onInAppEnabledChange={(value: boolean) => {
              userNotificationPreferenceCreateStore.setInAppEnabledValue(value);
            }}
            inAppEnabled={
              userNotificationPreferenceCreateStore.entityValues.inAppEnabled
            }
            emailEnabledError={
              userNotificationPreferenceCreateStore.errors.emailEnabled?.message
            }
            onEmailEnabledChange={(value: boolean) => {
              userNotificationPreferenceCreateStore.setEmailEnabledValue(value);
            }}
            emailEnabled={
              userNotificationPreferenceCreateStore.entityValues.emailEnabled
            }
            emailFrequencyError={
              userNotificationPreferenceCreateStore.errors.emailFrequency
                ?.message
            }
            emailFrequencyOptions={userNotificationPreferenceCreateStore.getEmailFrequencyOptions()}
            onEmailFrequencyChange={(value: EmailFrequency) => {
              userNotificationPreferenceCreateStore.setEmailFrequencyValue(
                value
              );
            }}
            emailFrequency={
              userNotificationPreferenceCreateStore.entityValues.emailFrequency
            }
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={userNotificationPreferenceCreateStore.isProcessing}
            onSave={() =>
              userNotificationPreferenceCreateStore.saveNewUserNotificationPreference()
            }
            onCancel={() =>
              userNotificationPreferenceCreateStore.cancelNewUserNotificationPreference()
            }
          />
          <ErrorDialog
            open={userNotificationPreferenceCreateStore.errorDialogOpened}
            title={userNotificationPreferenceCreateStore.errorTitle}
            description={userNotificationPreferenceCreateStore.errorDescription}
            onClose={() =>
              userNotificationPreferenceCreateStore.closeErrorDialog()
            }
          />
        </>
      );
    }
  );
